<template>
  <div class="overflow-hidden p-2">
    <b-row class="my-2">
      <b-col cols="4">
        <b-row v-if="getAmendmentTask.data != null">
          <b-col cols="12">
            <b-row>
              <b-col cols="12">
                <table class="min-w-full leading-normal mt-1 text-gray" style="border: solid 1px #dedede;">
                  <thead>
                  <tr class="bg-gray-pale">
                    <td colspan="12" class="px-2 py-2 font-bold">Attachments</td>
                  </tr>
                  <tr>
                    <th class="px-2 py-1">#</th>
                    <th class="px-2 py-1">File Name</th>
                    <th class="px-2 py-1 float-end">Action</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(file, idx) in getAmendmentTask.data.attachments" :key="idx" style="border: solid 1px #dedede;">
                    <td class="px-2 py-1">{{idx + 1}}</td>
                    <td class="px-2 py-1 text-capitalize">{{cleanName(file.fileDescription)}}</td>
                    <td class="px-2 py-1">
                      <button class="float-end bg-gray rounded text-white hover:bg-gray-dark px-2" @click="openFile(file)">Show</button>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-col>
      <b-col cols="8">
        <AmendmentAttachments v-if="getAmendmentTask.data.attachments" ref="attachmentScreen" />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment/moment";
import server from "@/app/env/server.json";
import AmendmentAttachments from "@/views/home/services/amendments/task/AmendmentAttachments";

export default {
  name: "AmendmentFiles",
  components: { AmendmentAttachments},
  data(){
    return{
      attachmentUrl:null
    }
  },
  mounted() {
    this.openFile(this.getAmendmentTask.data.attachments[0])
  },
  methods:{
    dateFormat(date){
      return moment(date).format("DD-MM-YYYY")
    },
    openFile(data){
      let fName = data ? data.fileName.trim() : ""
      this.attachmentUrl = server.IP+"/business-registration/filing/attachments/preview?file-name="+fName
      console.log(this.attachmentUrl)
    },
    cleanName(name){
      let n = name.replaceAll("_", " ")
      return n.toLowerCase()
    },
  },
  computed:{
    ...mapGetters(["getAmendmentTask"]),
  },
  watch:{
    attachmentUrl:{
      handler(url){
        this.$refs.attachmentScreen.openFile(url)
      },
      deep:true
    }
  }
}
</script>

<style scoped>
th, td{
  font-size: 12px;
}
</style>